import React from "react";
import { Link } from "react-router-dom";
import { Leaf, Sparkles } from "lucide-react";
import SustainabilityScore from "./SustainabilityScore";
import MerchantChip from "./MerchantChip";

const ProductCard = ({ product, onBuy }) => {
  return (
    <Link
      to={`/product/${product.id}`}
      className="group relative flex flex-col overflow-hidden card-premium hover:-translate-y-1 hover:shadow-2xl transition-all duration-300 ease-out"
      data-testid={`product-card-${product.id}`}
    >
      {/* Image */}
      <div className="relative aspect-[4/3] overflow-hidden bg-secondary">
        <img
          src={product.image}
          alt={product.name}
          className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute top-3 right-3">
          <div className="rounded-full bg-white/90 dark:bg-black/70 backdrop-blur-md p-1.5 shadow-lg">
            <SustainabilityScore score={product.sustainability_score} size={60} stroke={5} />
          </div>
        </div>
        {product.featured_tags?.includes("green-pick") && (
          <span className="absolute top-3 left-3 inline-flex items-center gap-1 rounded-full bg-emerald-600 text-white text-[10px] font-semibold px-2.5 py-1 shadow">
            <Leaf className="h-3 w-3" /> Green Pick
          </span>
        )}
      </div>

      {/* Content */}
      <div className="flex flex-col gap-2 p-5">
        <div className="flex items-center justify-between text-[11px] uppercase tracking-widest text-muted-foreground">
          <span className="truncate">{product.brand}</span>
          <MerchantChip name={product.merchant} size="sm" />
        </div>
        <h3 className="text-base font-semibold leading-snug line-clamp-2 min-h-[2.5rem]" data-testid="product-name">
          {product.name}
        </h3>

        <div className="flex items-baseline gap-2 mt-1">
          <span className="text-xl font-bold mono">₹{product.price}</span>
          {product.original_price > product.price && (
            <span className="text-sm text-muted-foreground line-through mono">₹{product.original_price}</span>
          )}
        </div>

        <div className="flex items-center gap-3 mt-2 text-xs">
          <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300 px-2.5 py-1 font-medium">
            <Sparkles className="h-3 w-3" /> ₹{product.cashback} back
          </span>
          <span className="inline-flex items-center gap-1 rounded-full bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-300 px-2.5 py-1 font-medium">
            <Leaf className="h-3 w-3" /> +{product.greencoins || product.green_points} GreenCoins
          </span>
        </div>

        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onBuy?.(product);
          }}
          className="btn-pill mt-3 bg-foreground text-background hover:bg-primary hover:text-primary-foreground"
          data-testid={`buy-now-${product.id}`}
        >
          Buy Now
        </button>
      </div>
    </Link>
  );
};

export default ProductCard;
